<script lang="ts">
    import { messagesToShow } from "./FloatingMessages.controller";
    import FloatingMessageSingle from "./FloatingMessageSingle.svelte";
</script>

<div class="floatinMessagesContainer">
    {#each $messagesToShow as message (message.id)}
        <FloatingMessageSingle {message} />
    {/each}
</div>

<style>
    .floatinMessagesContainer {
        position: fixed;
        bottom: 1rem;
        right: 1rem;
        max-width: calc(100% - 2rem);
        z-index: 1000;
        width: 30rem;
    }
</style>
